<script lang="ts">
  import { dndzone, SOURCES, TRIGGERS } from "svelte-dnd-action"
  import { getBase64 } from '../../helpers/index'
  import { publication_items } from "../../store";

  import TinyEditor from '@tinymce/tinymce-svelte'
  import HTMLContent from "../../../../../../custom/HTMLContent/HTMLContent.svelte"
  import UrlForm from "../UrlForm/UrlForm.svelte"
  import ItemActions from "./components/ItemActions/ItemActions.svelte"

  let dragDisabled: boolean = true;
  let isShowActions: boolean = false
  let isShowFileForm: boolean = false
  let isShowVideoForm: boolean = false
  let isShowAudioForm: boolean = false
  let isShowImageForm: boolean = false

  let files: File[]

  let video_url: string
  let video_url_2: string;
  let audio_url: string

  let conf = {
    setup: function (editor) {
      editor.ui.registry.addButton('customSaveButton', {
        text: 'Cохранить',
        onAction() {
          const editorText = editor.getContent()

          if (!editorText) {
            return
          }

          const item = $publication_items.find(({id}) => id === +editor.id)

          item.text = editorText
          item.isEdit = false

          editor.remove()

          $publication_items = $publication_items
        },
      });
    },

    menubar: false,
    language: 'ru',
    height: 300,
    block_formats: 'H2=h2;H3=h3;Text=p;',
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help',
    ],
    inline_styles : true,
    toolbar: 'bold italic underline strikethrough | numlist bullist | insert link | customSaveButton',
    font_formats: 'IBM Plex Sans',
    content_style: `
      @import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap");
      @import url("https://fonts.googleapis.com/css?family=Rubik+Moonrocks");

      * {
        font-family: IBM Plex Sans;
        color: #37352F;
        margin: 0;
      }

      h1 {
        font-family: IBM Plex Sans;
        font-size: 40px;
        font-weight: 600;
        line-height: 52px;
        letter-spacing: 0em;
        text-align: left;
      }

      h2 {
        styleName: IBM Plex 30 Semibold 30 (xl-lg);
        font-family: IBM Plex Sans;
        font-size: 30px;
        font-weight: 600;
        line-height: 39px;
        letter-spacing: 0em;
        text-align: left;
      }

      h3 {
        font-size: 20px;
        font-weight: 600;
        line-height: 29px;
        letter-spacing: 0em;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: 0em;
      }

      a {
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: 0em;
        color: #2B50ED;
        text-decoration: none;
      }

      h1, h2, h3, p {
        margin: 0 !important;
        margin-bottom: 16px !important;
      }

      ul, ol {
        margin: 0;
      }

      ol {
        padding: 0 16px;
      }

      ul {
        padding: 0 24px;
      }

      li {
        margin-bottom: 16px;
        line-height: 28px;
      }
    `
  }

  const handleConsider = (e) => {
    const {items: newItems, info: {source, trigger}} = e.detail;
		$publication_items = newItems;
    
		if (source === SOURCES.KEYBOARD && trigger === TRIGGERS.DRAG_STOPPED) {
			dragDisabled = true;
		}
	}

  const handleFinalize = (e) => {
		const { items: newItems, info: {source} } = e.detail
		
    $publication_items = newItems
	
		if (source === SOURCES.POINTER) {
			dragDisabled = true;
		}
	}

	const startDrag = (e) => {
		e.preventDefault();
		dragDisabled = false;
	}

	const handleKeyDown = (e) => {
		if ((e.key === "Enter" || e.key === " ") && dragDisabled) {
      dragDisabled = false;
    }
	}

  const transformDraggedElement = (draggedEl, data, index) => {
		draggedEl.style.border = '0px solid black'
	}

  const changeFileForm = () => {
    $publication_items = $publication_items
  }

  const itemActionsHandler = (event, itemId) => {
    const type = event.detail.type
    const indexItem = $publication_items.findIndex((elem) => elem.id === itemId)
    const item = $publication_items[indexItem]


    if (type === 'delete') {
      $publication_items = $publication_items.filter((el) => el.id !== item.id)
    }

    if (type === 'moveUp') {
      const prevItem = $publication_items[indexItem - 1]

      if (!prevItem) {
        return 
      }

      $publication_items[indexItem] = prevItem
      $publication_items[indexItem - 1] = item
    }

    if (type === 'moveDown') {
      const nextItem = $publication_items[indexItem + 1]

      if (!nextItem) {
        return
      }

      $publication_items[indexItem] = nextItem
      $publication_items[indexItem + 1] = item
    }

    $publication_items = $publication_items
  }

  $: isOpenTiny = $publication_items.some((item) => item.isEdit)

  const visibleActionsHandler = () => {
    if (isShowAudioForm) {
      isShowAudioForm = false
      return
    }

    if (isShowImageForm) {
      isShowImageForm = false
      return
    }

    if (isShowFileForm) {
      isShowFileForm = false
      return
    }

    if (isShowVideoForm) {
      isShowVideoForm = false;
      return
    }

    isShowActions = !isShowActions
  }

  const openAnotherAction = (type) => {
    if (type === 'text') {
      publication_items.update(n => {
        return [
          ...n, 
          { 
            id: $publication_items.length,
            item_type: type, 
            text: '',
            isEdit: true
          }
        ]
      })
    }

    if (type === 'video_url') {
      isShowVideoForm = true
    }

    if (type === 'doc') {
      isShowFileForm = true
    }

    if (type === 'audio_url') {
      isShowAudioForm = true
    }

    if (type === 'image') {
      isShowImageForm = true
    }

    isShowActions = false
  }

  const uploadFile = async () => {
    const base64File = await getBase64(files)

    publication_items.update(n => {
      return [
        ...n, 
        { 
          id: $publication_items.length,
          item_type: 'doc', 
          doc: { ...base64File } 
        }
      ]
    })
    
    isShowFileForm = false
  }

  const uploadImage = async () => {
    const base64File = await getBase64(files)

    publication_items.update(n => {
      return [
        ...n, 
        { 
          id: $publication_items.length,
          item_type: 'image', 
          image: { ...base64File } 
        }
      ]
    })

    isShowImageForm = false
  }

  const createAudio = () => {
    publication_items.update(n => {
      return [
        ...n, 
        { 
          id: $publication_items.length,
          item_type: 'audio_url', 
          audio_url
        }
      ]
    })

    isShowAudioForm = false
    audio_url = ''
  }

  const saveMultiItem = async () => {
    const item = {
      id: $publication_items.length,
      item_type: 'video_url',
    }

    if (files?.length) {
      const base64File = await getBase64(files);
      item.doc = { ...base64File };
    }

    if (audio_url) {
      item.audio_url = audio_url;
    }

    if (video_url) {
      item.video_url = video_url;
    }

    if (video_url_2) {
      item.video_url_2 = video_url_2;
    }

    publication_items.update(n => {
      return [
        ...n, 
        item
      ]
    })

    isShowVideoForm = false;
    video_url = '';
    video_url_2 = '';
    audio_url = '';
    files = [];
  }

  $: isOpenActions = isShowActions 
    || isShowFileForm 
    || isShowVideoForm
    || isShowAudioForm
    || isShowImageForm
</script>

<div class="wrapper">
  <div 
    class="items" 
    use:dndzone="{{ 
      items: $publication_items, 
      flipDurationMs: 0, 
      morphDisabled: true, 
      dropTargetStyle: { outline: 'none' },
      dragDisabled: dragDisabled || isOpenTiny,
      transformDraggedElement
    }}"
    on:consider="{handleConsider}"
    on:finalize="{handleFinalize}"
  >
    {#each $publication_items as item (item.id)}
      <div class="item">
        {#if !item.isEdit}
          <ItemActions 
            {dragDisabled} 
            on:keydown={handleKeyDown} 
            on:mousedown={startDrag}
            on:touchstart={startDrag}
            on:action={(e) => itemActionsHandler(e, item.id)}
          />
        {/if}

        {#if item.item_type === 'video_url'}
          <div class="file-form">
            {#if 'video_url' in item}
              <UrlForm 
                bind:url={item.video_url} 
                placeholder="Вставь ссылку на Youtube"
                on:create={changeFileForm}
              />
            {/if}

            {#if 'video_url_2' in item}
              <UrlForm 
                bind:url={item.video_url_2} 
                placeholder="Вставь ссылку на Kinescope"
                on:create={changeFileForm}
              />
            {/if}
          </div>

          {#if item.audio_url}
            <div class="file-form">
              <UrlForm 
                bind:url={item.audio_url} 
                placeholder="Вставь ссылку на аудио"
                on:create={changeFileForm}
              />
            </div>
          {/if}

          {#if item.doc}
            <div class="file">
              <i class="icon-document" />
              <div class="title">{item.doc.name}</div>
            </div>
          {/if}
        {/if}

        {#if item.item_type === 'image'}
          <img 
            src={`${item?.image?.base64.includes('data') ? item?.image?.base64 : `data:image/jpg;base64,${item?.image?.base64}`}`} 
            alt="Произошла ошибка при загрузке изображения" 
            class="image"
          />
        {/if}

        {#if item.item_type === 'text'}
          {#if item.isEdit}
            <TinyEditor 
              id={item.id}
              {conf} 
              bind:value={item.text}
              inline=true
              apiKey="4neoa79i1g4gdso4lq9ifuxs6k5474u5tbzo5p4ta0z9cyot"
            />
          {:else}
            <HTMLContent 
              value={item.text} 
              on:edit={() => item.isEdit = true} 
            />
          {/if}
        {/if}

        {#if item.item_type === 'doc'}
          <div class="file">
            <i class="icon-document" />
            <div class="title">{item?.doc?.name}</div>
          </div>
        {/if}

        {#if item.item_type === 'audio_url'}
          <div class="file-form">
            <UrlForm 
              bind:url={item.audio_url} 
              placeholder="Вставь ссылку на аудио"
              on:create={changeFileForm}
            />
          </div>
        {/if}
      </div>
    {/each}
  </div>

  {#if !isOpenTiny}
    <div class="created-actions">
      <div class="action open-actions" on:click={visibleActionsHandler}>
        <i class={isOpenActions ? 'icon-close' : 'icon-plus'} />
      </div>
    
      {#if isShowActions}
        <div class="actions">
          <div class="action" on:click={() => openAnotherAction('text')}>
            <i class="icon-text size-14" />
          </div>
          <div class="action">
            <i class="icon-image-1" on:click={() => openAnotherAction('image')} />
          </div>
          <div class="action">
            <i class="icon-video-1 size-14" on:click={() => openAnotherAction('video_url')} />
          </div>
          <div class="action">
            <div class="flex" on:click={() => openAnotherAction('audio_url')}>
              <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 17.4782C7 19.135 5.65685 20.4782 4 20.4782C2.34315 20.4782 1 19.135 1 17.4782C1 15.8213 2.34315 14.4782 4 14.4782C5.65685 14.4782 7 15.8213 7 17.4782ZM7 17.4782V8.47816M17 14.4782C17 16.135 15.6569 17.4782 14 17.4782C12.3431 17.4782 11 16.135 11 14.4782C11 12.8213 12.3431 11.4782 14 11.4782C15.6569 11.4782 17 12.8213 17 14.4782ZM17 14.4782V5.47816M7 8.47816L17 5.47816M7 8.47816V4.98676C7 4.0938 7.59195 3.30903 8.45056 3.06371L10.5 2.47816L15.0884 1.06633C16.0383 0.774055 17 1.48432 17 2.47816V5.47816" stroke="#22252C" stroke-width="1.8" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
          <div class="action">
            <i class="icon-document" on:click={() => openAnotherAction('doc')} />
          </div>
        </div>
      {/if}
    
      {#if isShowAudioForm}
        <div class="file-form video-url">
          <div class="title video-url">
            <input 
              placeholder="Вставь ссылку на аудио" 
              type="text"
              bind:value={audio_url}
            />
    
            {#if audio_url}
              <i class="icon-check" on:click={createAudio} />
            {/if}
          </div>
        </div>
      {/if}
    
      {#if isShowVideoForm}
        <div class="flex flex-col gap-1">
          <UrlForm 
            bind:url={video_url_2} 
            placeholder="Вставь ссылку на Kinescope"
          />

          <UrlForm 
            bind:url={video_url} 
            placeholder="Вставь ссылку на Youtube"
          />

          <UrlForm 
            bind:url={audio_url} 
            placeholder="Вставь ссылку на аудио"
          />

          <label for="action-upload-photo" class="file-form">
            <div class="title">
              <div class="text-ellipsis overflow-hidden whitespace-nowrap">
                {files?.[0]?.name || 'Загрузить файл'}
              </div>
              <i class="icon-upload" />
            </div>
          </label>

          <input 
            bind:files 
            type="file" 
            name="photo" 
            id="action-upload-photo"
            accept="application/msword, application/vnd.ms-excel, text/plain, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />

          {#if video_url || video_url_2}
            <button 
              type="button" 
              class="save-multi-item-button"
              on:click={saveMultiItem}
            >
              Сохранить
            </button>
          {/if}
        </div>
      {/if}
    
      {#if isShowFileForm}
        <label for="action-upload-photo" class="file-form">
          <div class="title">
            <div>Загрузить файл</div>
            <i class="icon-upload" />
          </div>
        </label>
    
        <input 
          bind:files 
          type="file" 
          name="photo" 
          id="action-upload-photo"
          accept="application/msword, application/vnd.ms-excel, text/plain, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          on:change={uploadFile}
        />
      {/if}
    
      {#if isShowImageForm}
        <label for="action-upload-photo" class="file-form">
          <div class="title">
            <div>Загрузить файл</div>
            <i class="icon-upload" />
          </div>
        </label>
    
        <input 
          bind:files 
          type="file" 
          name="photo"
          accept="image/*"
          id="action-upload-photo"
          on:change={uploadImage}
        />
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">  
  #action-upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }

  .save-multi-item-button {
    ont-weight: 600;
    line-height: 20px;
    text-align: center;
    color: white;
    padding: 8px;
    background-color: #2B50ED;
    border: none;
    border-radius: 30px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .open-actions {
    margin-right: 40px;
  }

  .created-actions {
    display: flex;
    align-items: center;
    min-height: 58px;

    .file-form {
      min-width: 152px;
      box-sizing: border-box;
      color: #2B50ED;
      font-size: 10px;
      font-weight: 600;
      line-height: 18px;
      border-radius: 8px;
      padding: 8px;
      box-shadow: 0px 9px 27px 0px #00000012;
      cursor: pointer;

      &.video-url {
        width: 230px;

        i {
          color: #12C97A;
          background: #D0F1E1;
          border-radius: 50px;
          font-size: 12px !important;
          margin: 0 !important;
          display: flex;
          padding: 6px;
          justify-content: center;
          align-items: center;
          position: absolute;
          right: 8px;
        }
      }

      input {
        border: none;
        background-color: #E0E8F6;
        outline: none;
        color: #22252C;
        font-size: 10px;
        line-height: 18px;
        width: 100%;

        &::placeholder {
          color: #2B50ED;
          font-size: 10px;
          line-height: 18px;
          letter-spacing: 0em;
        }
      }

      .title {
        display: flex;
        align-items: center;
        background-color: #E0E8F6;
        border-radius: 4px;
        padding: 11px 16px;

        &.video-url {
          padding: 11px 8px;
          position: relative;
        }

        i {
          font-size: 14px;
          margin-left: 12px;

          &:before {
            margin: 0;
          }
        }
      }
    }
    
    .action {
      box-shadow: 0 3px 4px 0 #0000001A;
      cursor: pointer;
      border-radius: 50px;
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 16px;

        &::before {
          width: auto;
        }

        &.size-14 {
          font-size: 14px;
        }
      }
    }

    .actions {
      display: flex;

      .action {
        margin-right: 16px;
      }
    }
  }

  .file-form {
    width: 230px;
    margin-bottom: 16px;
  }

  .file {
    display: flex;
    align-items: center;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.04em;  
    color: #2B50ED;
    margin-bottom: 16px;

    i {
      margin-right: 9px;
      font-size: 16px;
    }
  }

  .wrapper {
    border: 1px solid #B6C8F9;
    padding: 32px;
    border-radius: 10px;
    margin-bottom: 24px;

    .items {
      .item {
        position: relative;

        .image {
          margin-bottom: 16px;
          width: 50%;
        }
      }
    }
  }
</style>